import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import * as documentPackageActions from "@rentiohq/shared-frontend/dist/reduxV2/documentPackage/documentPackage.actions";
import * as documentPackageSelectors from "@rentiohq/shared-frontend/dist/reduxV2/documentPackage/documentPackage.selectors";
import * as documentHooks from "@rentiohq/shared-frontend/dist/reduxV2/documents/document.hooks";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loading } from "../Loading";
export var DocumentFetchListItem = function (props) {
    var document = props.document, documentId = props.documentId, renderDocument = props.renderDocument, renderLoading = props.renderLoading, renderError = props.renderError, _a = props.fetchDocumentPackage, fetchDocumentPackage = _a === void 0 ? false : _a, extraQueryParams = props.extraQueryParams;
    // Redux
    var dispatch = useDispatch();
    var _b = documentHooks.useDetail({
        shouldRefetch: false,
        id: document ? undefined : documentId,
        extraQueryParams: extraQueryParams,
    }), fetchedDocument = _b.detail, isFetching = _b.isFetching, fetchError = _b.fetchError;
    var anyDocument = fetchedDocument || document;
    var documentPackage = useSelector(function (state) {
        return (anyDocument === null || anyDocument === void 0 ? void 0 : anyDocument.documentPackageId)
            ? documentPackageSelectors.getDetail(state, anyDocument === null || anyDocument === void 0 ? void 0 : anyDocument.documentPackageId)
            : undefined;
    });
    // Lifecycle
    React.useEffect(function () {
        var anyDocument = fetchedDocument || document;
        if (!(anyDocument === null || anyDocument === void 0 ? void 0 : anyDocument.documentPackageId) || !fetchDocumentPackage) {
            return;
        }
        if (documentPackage) {
            return;
        }
        dispatch(documentPackageActions.getDetailStart.getAction({
            id: anyDocument.documentPackageId,
        }));
    }, [anyDocument]);
    // Render
    if (document) {
        return _jsx(_Fragment, { children: renderDocument(document, documentPackage) });
    }
    if (fetchedDocument) {
        return _jsx(_Fragment, { children: renderDocument(fetchedDocument, documentPackage) });
    }
    if (isFetching) {
        return (renderLoading === null || renderLoading === void 0 ? void 0 : renderLoading()) || _jsx(Loading, { asDots: true });
    }
    if (fetchError && renderError) {
        return renderError(fetchError);
    }
    return null;
};
